import { supabase } from './supabaseClient';

// Genera la descripción del producto con Claude, vía la Edge Function
// generar-descripcion (la API key vive en Supabase, nunca en el navegador).
export async function generarDescripcion({ nombre, categoria, marca, talla, color, unidad }) {
  const { data, error } = await supabase.functions.invoke('generar-descripcion', {
    body: { nombre, categoria, marca, talla, color, unidad },
  });
  if (error) throw error;
  if (!data?.descripcion) throw new Error(data?.error || 'Respuesta vacía de la IA');
  return data.descripcion;
}
